export default {
  labels: {
    card: 'Karta kredytowa',
    bank_account: 'Konto bankowe',
  },
  alerts: {
    payments_not_configured:
      'Płatności nie są jeszcze skonfigurowane. Skontaktuj się z dostawcą, aby je włączyć, a następnie wróć do tego kroku.',
  },
  buttons: {
    change_payment_method: 'Zmień metodę płatności',
    save_payment_info: 'Zapisz dane płatności',
  },
  toasts: {
    failed_to_init_payment_setup: 'Nie udało się zainicjować konfiguracji płatności, odśwież stronę',
    successfully_saved_payment_method: 'Dane płatności zostały zapisane',
  },
};
